<div class="client-select-body">
  <img class="client-select-logo" src="assets/SCRAII_LoginLogo.svg" alt="SCRAII" />
  <h2 class="client-select-title">Select Client</h2>

  <mat-form-field appearance="outline" class="matFformFieldClient">
    <mat-label>Client Name</mat-label>
    <mat-select [(ngModel)]="selectedClient" panelClass="client-select-panel">
      <mat-option *ngFor="let client of clients" [value]="client">{{client.client_nm }}</mat-option>
    </mat-select>
  </mat-form-field>

  <div class="client-select-actions">
    <button
      type="button"
      class="btn btn-primary btn-sm confirmBtnHomePopups"
      matTooltipClass="expand-tooltip"
      [disabled]="!selectedClient"
      (click)="clientSelection(selectedClient)"
    >
      Confirm
    </button>
  </div>
</div>
